import { LOGIN } from '../constants/actionTypes';

const login = (authResponse) => ({
    type: LOGIN,
    authResponse,
  });

export default login;
